// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ra5v","colBig":"styles_colBig__2uMbq","colSmall":"styles_colSmall__1gEkC","shopifyNameWrapper":"styles_shopifyNameWrapper__nz-k3"};